import { IPage } from "@/types/AppTypes";
import { httpRequest } from "@/utils/HttpRequest";
import { IWbpDetail, IWbpInsert, IWbpSearch, IWbpUpdate } from "./wbpTypes";


class WbpService {
    async page(searchVo: IWbpSearch, config: object = {}) {
        const apiUrl = "/gtm/sale/listPage";
        return await httpRequest.post<IPage<IWbpDetail>>(apiUrl, searchVo, config);
    }
    async pageBySupplier(searchVo: { "code": string, "shopCode": string }, config: object = {}) {
        const apiUrl = "/gtm/sale/selectBySupplier";
        return await httpRequest.post<IWbpDetail[]>(apiUrl, searchVo, config);
    }
    async one(id: string) {
        const apiUrl = `/gtm/sale/findByIdOrCode/${id}`;
        return await httpRequest.get<IWbpDetail>(apiUrl);
    }
    async insert(insertVo: IWbpInsert) {
        const apiUrl = "/gtm/sale/insert";
        return await httpRequest.post<string>(apiUrl, insertVo);
    }
    async update(updateVo: IWbpUpdate) {
        const apiUrl = "/gtm/sale/update";
        return await httpRequest.post<string>(apiUrl, updateVo);
    }
    //导入
    async import(file: { file: File }) {
        const appPageUrl = "/gtm/sale/import";
        return await httpRequest.post<boolean>(appPageUrl, file);
    }
    //导出
    async export(searchVo: IWbpSearch) {
        const appPageUrl = "/gtm/sale/export";
        return await httpRequest.postFile<boolean>(appPageUrl, searchVo, { timeout: 300000 });
    }
    //下载模板
    async downloadTpl() {
        const appPageUrl = "/gtm/sale/downloadTpl";
        return await httpRequest.getFile(appPageUrl);
    }

}

export const wbpService = new WbpService();
